<div class="container mb-5">
  <div class="row align-items-center">
    <div class="col">

      <!-- Nav -->
      <ul class="nav nav-tabs nav-overflow header-tabs">
        <li class="nav-item">
          <a (click)="this.isMainSpouseTab = true" [class.active]="this.isMainSpouseTab" class="nav-link"
            id="form-tab-link">
            Formulaire principal
          </a>
        </li>
        <li class="nav-item">
          <a (click)="this.isMainSpouseTab = false" [class.active]="this.isMainSpouseTab === false" class="nav-link"
            id="form-tab-spouse-link">
            Formulaire conjoint
          </a>
        </li>
      </ul>

    </div>
  </div>
</div>

<!-- Form -->
<form (ngSubmit)="this.advancedForm.submit()" [formGroup]="this.advancedForm">


  <div [hidden]="isMainSpouseTab === false" class="container">
    <app-quebec-2023-tax-questionnaire
      [advancedForm]="advancedForm"
      [baseSpouseForm]="advancedForm"
    [isMainSpouse]="true"></app-quebec-2023-tax-questionnaire>
  </div>

  <div [hidden]="isMainSpouseTab === true" class="container">
    @if ((advancedForm.value.civilStatus === civilStatusEnum.LivingCommonLaw || advancedForm.value.civilStatus === civilStatusEnum.Married) && advancedForm.value.isSpouseTaxPrepared) {
      <app-quebec-2023-tax-questionnaire
        [advancedForm]="advancedForm"
        [baseSpouseForm]="advancedForm.formElements.spouseTaxForm"
      [isMainSpouse]="false"></app-quebec-2023-tax-questionnaire>
    }

    @if (!(advancedForm.value.civilStatus === civilStatusEnum.LivingCommonLaw || advancedForm.value.civilStatus === civilStatusEnum.Married) || advancedForm.value.isSpouseTaxPrepared === false) {
      <div
        class="alert alert-warning"
        role="alert">
        <i class="fas fa-exclamation-triangle"></i> Pour remplir la declaration du conjoint veuillez répondre oui à
        la question 'Est-ce que la déclaration du conjoint sera produite par notre cabinet?'.
      </div>
    }
  </div>


  <br>
    <br>
      <br>
        <br>

          <!-- Button -->
          <div class="container-fluid fixed-bottom">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <magieno-button [button]="this.advancedForm.getButton('SAVE')" id="saveFormButton"></magieno-button>

                  <magieno-button [button]="this.advancedForm.getButton('SUBMIT')" id="submitFormButton"
                  style="margin-left: 12px"></magieno-button>

                  <!--            <span class="badge rounded-pill ms-5" style="font-size: 12pt;"-->
                  <!--                  [class.bg-light]="calculationStatusEnum === 'CREATED'"-->
                  <!--                  [class.bg-warning]="calculationStatusEnum === 'IN_PROGRESS'"-->
                  <!--                  [class.bg-danger]="calculationStatusEnum === 'ERROR'"-->
                  <!--                  [class.bg-success]="calculationStatusEnum === 'COMPLETED'"-->

                <!--            >{{ getStatusText() }}</span>-->

                <span [class.bg-danger]="this.numberOfErrors > 0" [class.bg-success]="this.numberOfErrors === 0"
                  class="badge rounded-pill ms-3"
                  style="font-size: 12pt;">{{ this.numberOfErrors }}
                erreurs</span>
                <!--            <span style="margin-left: 15px;">Dernière sauvegarde: <strong>{{ getLastModifiedText() }}</strong></span>-->

              </div>
            </div>
          </div>
        </div>


      </form>